import { GridRecord } from '../../components/Grid/GridDataTypes';
import { validateAgainst } from '../validation/validateAgainst';
import {
  CreateUpdateParamsDto,
  CreateUpdateParamsDtoFromJSON,
  DefaultApi,
  GetLastEditorDto,
  GetParamsDto,
} from '../autogenerated/spdApiClient';
import { paramsForGrid } from '../../../app/components/Params/ParamsSearch';
import { ParamsSchema } from '../validation/schemas';

export interface ParamsContextInterface {
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  update: (id: string, dto: CreateUpdateParamsDto) => Promise<void>;
  getById: (id: string) => Promise<GetParamsDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
  getReportLastDays: () => Promise<number | undefined>;
}

export const ParamsContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.paramsControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
      );

      return data.map(item => paramsForGrid(item));
    },
    getAllCount: async (filterText?: string, filterColumns?: string) =>
      api.paramsControllerGetAllCount(filterText || '', filterColumns),
    update: (id: string, dto: CreateUpdateParamsDto) =>
      api.paramsControllerUpdate(id, dto),
    getById: (id: string) => api.paramsControllerGetById(id),
    getLastEditor: (id: string) => api.paramsControllerGetLastEditor(id),
    getReportLastDays: async () => {
      const value = await api.paramsControllerGetReportLastDaysNumber();
      const parsed = typeof value === 'number' ? value : Number(value);

      return Number.isFinite(parsed) && parsed > 0
        ? Math.floor(parsed)
        : undefined;
    },
  };
};

export const validate = (param: CreateUpdateParamsDto) =>
  validateAgainst(ParamsSchema, param);

export const convert = (param: GetParamsDto) => {
  return CreateUpdateParamsDtoFromJSON(param);
};
